import styled, { createGlobalStyle } from "styled-components";
import {
  FlexSection,
  FlexContainer,
  Button,
  FlexDiv,
  SVGSprite,
  Box,
} from "../../../components/Atoms";
import Typography from "../../../foundation/Typography/V2";

export const Wrapper = styled(FlexSection)`
  margin-top: ${({ topDistance }) => -topDistance + "px"};
  background: linear-gradient(
      180deg,
      ${({ theme }) => theme.colorsV2.primary.shade_25} 0%,
      ${({ theme }) => theme.colorsV2.primary.shade_100} 100%
    ),
    ${({ theme }) => theme.colorsV2.blueGray.shade_100};
  padding: 88px 16px 0;
  @media only screen and (max-width: 1024px) {
    padding: 135px 16px 0;
  }
`;

export const Container = styled(FlexContainer)`
  padding: 88px 16px 56px;
  @media only screen and (max-width: 1079px) {
    padding: 0;
  }
`;

export const LeftSection = styled(FlexDiv)`
  flex-direction: column;
  width: 100%;
  padding: ${({ heroStyles }) =>
    heroStyles?.backgroundImage?.padding || "46px 16px 52px"};
  background-image: ${({ image }) => `url("${image}")`};
  background-repeat: no-repeat;
  background-position-x: right;
  ${({ heroStyles }) =>
    `background-size: ${
      heroStyles?.backgroundImage?.backgroundSize || "contain"
    }`};

  @media only screen and (max-width: 1024px) {
    background-image: none;
    padding: 32px 8px 56px;
  }
`;

export const Title = styled(Typography)`
  margin: 0 0 30px;
  color: ${({ theme }) => theme.colorsV2.primary.shade_800};
  max-width: 700px;
  * {
    font-size: inherit;
    line-height: inherit;
    font-family: inherit;
    color: inherit;
  }
  @media only screen and (max-width: 1023px) {
    padding: 0;
    text-align: center;
    margin: 0 0 25px;
  }
`;

export const SubTitle = styled(Typography)`
  margin: 0 0 30px;
  max-width: 700px;
  * {
    font-size: inherit;
    line-height: inherit;
    font-family: inherit;
    color: inherit;
  }
  @media only screen and (max-width: 1023px) {
    padding: 0;
    text-align: center;
    margin: 0 0 25px;
  }
`;

export const Description = styled(Typography)`
  margin: 0 0 30px;
  max-width: 700px;

  font-size: 20px;
  line-height: 24px;
  font-family: inherit;

  @media only screen and (max-width: 1023px) {
    padding: 0;

    font-size: 15px;
    line-height: 18px;
    text-align: left;
    margin: 0 0 25px;
  }
`;

export const FeaturesDiv = styled(FlexDiv)`
  flex-wrap: wrap;

  @media only screen and (max-width: 1023px) {
    margin-bottom: 40px;
    justify-content: space-between;
    padding: 0 16px;
  }
`;

export const FeatureItem = styled(FlexDiv)`
  flex-direction: column;
  position: relative;
  padding: 0 40px;
  margin-top: 8px;
  margin-right: 40px;
  max-width: 236px;
  width: 100%;
  &:last-child {
    margin-right: 0;
    &:after {
      content: normal;
    }
  }
  &:after {
    content: "";
    border-right: 1px solid ${({ theme }) => theme.colorsV2.gray.shade_300};
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    max-height: calc(100% - 8px);
    height: 100%;
  }
  @media only screen and (max-width: 992px) {
    margin-top: 0;
    max-width: 160px;
    margin-right: 8px;
    padding: 0 0 0 40px;
    max-width: calc(33.33% - 8px);
    &:last-child {
      margin-right: 0px;
    }
  }
  @media only screen and (max-width: 767px) {
    &:after {
      content: normal;
    }
    max-width: calc(50% - 8px);
  }
`;

export const FeatureTitle = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.shyft.purple_text};
`;

export const FeatureSubtitle = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.shyft.purple_text};
`;

export const Stars = styled(SVGSprite)`
  fill: ${({ theme }) => theme.colorsV2.warning.shade_300};
  height: 32px;
  width: 32px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
`;

export const ButtonDiv = styled(FlexDiv)`
  @media only screen and (max-width: 1279px) {
    flex-direction: column;
    gap: 16px;
    align-items: center;
  }
`;

export const PrimaryCTA = styled(Button)`
  margin-right: 8px;
  padding: 11px 32px;
  box-shadow: 0px 10px 20px
      rgba(${({ theme }) => theme.colors.shadows.purple_3}, 0.18),
    0px 2px 6px rgba(${({ theme }) => theme.colors.shadows.purple_3}, 0.12),
    0px 0px 1px rgba(${({ theme }) => theme.colors.shadows.black}, 0.04);
  &:last-child {
    margin-right: 0;
  }
  @media only screen and (max-width: 992px) {
    line-height: 32px;
    padding: 9px 24px;
  }
`;

export const SecondaryCTA = styled(PrimaryCTA)`
  padding-right: 16px;
  padding-left: 40px;
  p {
    display: flex;
    align-items: center;
  }
  @media only screen and (max-width: 992px) {
    padding: 8px 8px 8px 32px;
  }
`;

export const Span = styled(Typography)`
  height: 32px;
  width: 32px;
  border-radius: 50%;
  margin-left: 24px;
  background-color: ${({ theme }) => theme.colorsV2.primary.shade_800};
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const ArrowRight = styled(SVGSprite)`
  fill: ${({ theme }) => theme.colors.white};
  height: 16px;
  width: 16px;
`;

export const OverrideHeaderStyle = createGlobalStyle`
header{
  position:relative;
}
`;

export const InnerTop = styled(FlexDiv)`
  flex-direction: column;
  @media only screen and (max-width: 1279px) {
    padding: 40px 8px 16px;
    margin-bottom: 24px;
  }
`;

export const IconRing = styled(Box)`
  // height: 72px;
  // width: 72px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.shadeRed};
  overflow: hidden;
`;

export const HealthBox = styled(Box)`
  max-width: 140px;
  padding: 0 12px;
  margin-bottom: 16px;
  @media only screen and (max-width: 992px) {
    max-width: 115px;
  }
`;
